export default {"src":"/_next/static/media/logo.721ea38d.svg","height":48,"width":215,"blurWidth":0,"blurHeight":0};